import useTheme from '@mui/material/styles/useTheme';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Typography from '@mui/material/Typography';
import { shallow } from 'zustand/shallow';
import { OOHRow } from '../../../../../../../../../../api/services/mediaPlanning/offline/oohBudget';
import { useCountriesDataStore } from '../../../../../../../../../../store/countriesDataStore';
import usePlanStore from '../../../../../../../../../../store/planStore';
import { Countries } from '../../../../../../../../../../shared/enums';
import { formatNumberWithSpaces } from '../../../../../../../common/BudgetTable/utils/formatNumberWithSpaces';

export interface TotalOOHRowProps {
  data: OOHRow[];
}

export default function TotalOOHRow({ data }: TotalOOHRowProps) {
  const { selectedCountryISOCode } = usePlanStore();
  const optionalIds = useCountriesDataStore(
    (state) => state[selectedCountryISOCode! as Countries]?.optionalIds,
    shallow
  );
  const normalizeText = (text: string) => text.replace(/\s+/g, ' ').trim();

  const totalBudget = data.reduce(
    (acc, oohRow) => {
      const { budget, isRequired, format, variant } = oohRow;
      const formattedKey = normalizeText(`${format}${variant || ''}`);

      const filteredKeys = Object.entries(optionalIds || {}).filter(
        (entry) => entry[1] === true
      );

      const optionalKeys = filteredKeys.map((key) => normalizeText(key[0]));

      if (isRequired || optionalKeys.includes(formattedKey)) {
        return {
          currency: budget.currency,
          value: acc.value + (budget.value || 0),
        };
      }
      return acc;
    },
    { currency: '', value: 0 }
  );

  const { palette } = useTheme();
  return (
    <TableRow
      sx={{
        background: palette.oohTable.background.total,
        height: '65px',
        borderTop: '1px solid #8193b4',
      }}
    >
      <TableCell />
      <TableCell />
      <TableCell />
      <TableCell />
      <TableCell />
      <TableCell align="center">
        <Typography
          textTransform="uppercase"
          variant="body2"
          sx={{
            color: palette.textLight.main,
            fontWeight: 900,
          }}
        >
          Total OOH:
        </Typography>
      </TableCell>
      <TableCell align="right" sx={{ paddingRight: '24px' }}>
        <Typography
          variant="body2"
          sx={{
            color: palette.textLight.main,
            fontWeight: 900,
          }}
        >
          {formatNumberWithSpaces(totalBudget.value.toFixed(0))}
        </Typography>
      </TableCell>
    </TableRow>
  );
}
